<template>
  <!--  页脚-->
  <div class="footerBar-box">

  </div>
</template>

<script>
export default {
  name: "footerBar"
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/footerBar.vue